<template>
  <teleport to="body">
    <div class="fenetre-fond" @mousedown.self="fermerSiPermis" @keydown.esc="fermerSiPermis">
      <div class="fenetre" :class="taille" role="dialog" aria-modal="true" :aria-label="titre" ref="boite" tabindex="-1">
        <div class="fenetre-tete">
          <h3>{{ titre }}</h3>
          <button type="button" class="btn btn-sm btn-light" @click="$emit('fermer')" aria-label="Fermer"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="fenetre-corps"><slot /></div>
        <div class="fenetre-pied" v-if="$slots.pied"><slot name="pied" /></div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "Fenetre",
  props: { titre: String, taille: { type: String, default: "" }, fermable: { type: Boolean, default: true } },
  emits: ["fermer"],
  mounted() {
    this.$nextTick(() => {
      const champ = this.$refs.boite?.querySelector("input:not([type=hidden]),select,textarea");
      (champ || this.$refs.boite)?.focus();
    });
  },
  methods: {
    fermerSiPermis() {
      if (this.fermable) this.$emit("fermer");
    }
  }
};
</script>
